import React, { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import CreateLot from "./CreateLot";

// this is the function that will open the accordion and below I put the Room create inside of it
function LotAccordion(props) {
  const [open, setOpen] = useState("0");
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <div style={{ paddingTop: "30px " }}>
      <Accordion open={open} toggle={toggle}>
        <AccordionItem>
          <AccordionHeader targetId="1">Create Parking Lot</AccordionHeader>
          <AccordionBody accordionId="1">
            <CreateLot
              token={props.token}
              getAllLots={props.getAllLots}
              // lots={lots}
            />
          </AccordionBody>
        </AccordionItem>
      </Accordion>
    </div>
  );
}

export default LotAccordion;
